export interface ErrorResponse {
  status: number
  data: {
    detail: {
      error_message: string
      error_code: string
    }
  }
}

export const isErrorResponse = (response: any): response is ErrorResponse => {
  return (
    response.status &&
    response.data &&
    response.data.detail &&
    response.data.detail.error_message &&
    response.data.detail.error_code
  )
}
